import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {convertSecondsToMMSSFormat} from '@Utils/date.util';
import {useAppSelector} from '@/hooks';
import {getCurrentPageTimeFloored} from '@Components/poster-editor/poster-editor-reducer';

export function CurrentTimeText(): ReactElement<any> {
  const currentPageTime = useAppSelector(getCurrentPageTimeFloored);
  const getCurrentTime = (): ReactElement<any> => {
    return (
      <>
        <Text val={`${convertSecondsToMMSSFormat(currentPageTime)} /`} size={TextSize.XXSMALL} />
        &nbsp;
      </>
    );
  };

  return getCurrentTime();
}
